'use strict';

// ----------------------------------------
// Imports
// ----------------------------------------

import '../_vendors/passfield.min';

// ----------------------------------------
// Public
// ----------------------------------------

function initPassfield () {
	var $password = $('.password');

	$password.passField({
		showGenerate: false,
		acceptRate: 0,
		locale: 'pl'
	});
}

// ----------------------------------------
// Exports
// ----------------------------------------

export {initPassfield};



// WEBPACK FOOTER //
// ./src/js/_modules/pass-field.js